import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../../slices';
import {
  Tabs,
  Button,
  InputField,
  IconChevron,
  ModalWrapper,
  ModalGeneric,
  MessageBox,
} from '@payright/web-components';
import LoggedInLayout from '../../layouts/logged-in-layout';
import { Grid, Row, Col } from 'react-flexbox-grid';
import getConstants from '../../util/constants';
import Loader from '../../components/loader';
import { showHideItemsAndMenu } from '../../util/helper';
import { LoanDetailsSuccessResponse } from '../../util/merchant-api';
import { CustomerResourceBasic } from '@merchant-portal/types/customer';
import SCLoanDetails from './loan-detail-css';
import { activateLoan, displayLoanDetails } from '@merchant-portal/slices/loans';

const {
  LOAN_APPROVED_STATUS,
  SUCCESSFUL_LOAN_ACTIVATION,
  LOAN_ACTIVATION_CONFIRMATION,
  REQUEST_FAILURE,
} = getConstants();

const LoanDetail = (loan: any) => {
  const dispatch = useDispatch();
  const { errorMessage, loanDetails, loanCustomer, loading, submitSucceeded } = useSelector(
    (state: RootState) => state.loans
  );
  const [showLoanActivationModal, setShowLoanActivationModal] = useState(false);
  const { accessItems } = showHideItemsAndMenu();
  let showMessage;

  // Method to close Loan Activation Modal after message display
  const handleCloseLoanActivationModal = () => {
    setShowLoanActivationModal(false);
    dispatch(displayLoanDetails(loan.match.params.id));
  };

  useEffect(() => {
    dispatch(displayLoanDetails(loan.match.params.id));
  }, [dispatch, loan.match.params.id]);

  if (submitSucceeded) {
    showMessage = (
      <MessageBox
        title={SUCCESSFUL_LOAN_ACTIVATION}
        message=""
        handleOnClick={handleCloseLoanActivationModal}
      />
    );
  } else if (errorMessage) {
    showMessage = (
      <MessageBox
        title={REQUEST_FAILURE}
        message=""
        handleOnClick={handleCloseLoanActivationModal}
        error={true}
      />
    );
  }

  const renderLoanDetailsTab = (loanDetails: LoanDetailsSuccessResponse) => {
    return (
      <div className="details-wrapper-body">
        <Grid fluid>
          <Row>
            <Col xs={12} md={12} lg={3}>
              <h4>Loan Breakdown</h4>
            </Col>
            <Col xs={12} md={12} lg={8}>
              <Row>
                <Col xs={12} md={12} lg={5}>
                  <Row start="xs">
                    <Col xs={12} md={6} lg={6}>
                      <h5>Loan Purpose</h5>
                    </Col>
                    <Col xs={9} md={6} lg={3} xsOffset={3}>
                      <h6>{loanDetails.loanPurpose}</h6>
                    </Col>
                  </Row>

                  <Row end="xs">
                    <Col xs={12} md={12} lg={12}>
                      <div className="border-row"></div>
                    </Col>
                  </Row>

                  <Row start="xs">
                    <Col xs={12} md={6} lg={6}>
                      <h5>Loan Amount</h5>
                    </Col>
                    <Col xs={9} md={6} lg={3} xsOffset={3}>
                      <h6>${loanDetails.saleAmount}</h6>
                    </Col>
                  </Row>

                  <Row start="xs">
                    <Col xs={12} md={12} lg={12}>
                      <div className="border-row"></div>
                    </Col>
                  </Row>

                  <Row start="xs">
                    <Col xs={12} md={6} lg={6}>
                      <h5>Origination Fee</h5>
                    </Col>
                    <Col xs={9} md={6} lg={3} xsOffset={3}>
                      <h6>${loanDetails.establishmentFee}</h6>
                    </Col>
                  </Row>

                  <Row start="xs">
                    <Col xs={12} md={12} lg={12}>
                      <div className="border-row"></div>
                    </Col>
                  </Row>

                  <Row start="xs">
                    <Col xs={12} md={6} lg={6}>
                      <h5>Loan Management Fee</h5>
                    </Col>
                    <Col xs={9} md={6} lg={3} xsOffset={3}>
                      <h6>${loanDetails.loanManagementFee}</h6>
                    </Col>
                  </Row>

                  <Row start="xs">
                    <Col xs={12} md={12} lg={12}>
                      <div className="border-row"></div>
                    </Col>
                  </Row>

                  <Row start="xs">
                    <Col xs={12} md={6} lg={6}>
                      <h5>Loan Duration</h5>
                    </Col>
                    <Col xs={9} md={6} lg={3} xsOffset={3}>
                      <h6>{loanDetails.terms} months</h6>
                    </Col>
                  </Row>

                  <Row start="xs">
                    <Col xs={12} md={12} lg={0}>
                      <div className="border-row"></div>
                    </Col>
                  </Row>
                </Col>

                <Col xs={12} md={12} lg={6} lgOffset={1}>
                  <Row start="xs">
                    <Col xs={12} md={6} lg={6}>
                      <h5>Loan repayment frequency</h5>
                    </Col>
                    <Col xs={9} md={6} lg={3} xsOffset={3}>
                      <h6>{loanDetails.repaymentFrequency}</h6>
                    </Col>
                  </Row>

                  <Row start="xs">
                    <Col xs={12} md={12} lg={12}>
                      <div className="border-row"></div>
                    </Col>
                  </Row>

                  <Row start="xs">
                    <Col xs={12} md={6} lg={6}>
                      <h5>
                        No. of interest-free loan <br />
                        repayments
                      </h5>
                    </Col>
                    <Col xs={9} md={6} lg={3} xsOffset={3}>
                      <h6>{loanDetails.interestFreeRepayments}</h6>
                    </Col>
                  </Row>

                  <Row start="xs">
                    <Col xs={12} md={12} lg={12}>
                      <div className="border-row"></div>
                    </Col>
                  </Row>

                  <Row start="xs">
                    <Col xs={12} md={6} lg={6}>
                      <h5>
                        No. of interest-bearing <br />
                        loan repayments
                      </h5>
                    </Col>
                    <Col xs={9} md={6} lg={3} xsOffset={3}>
                      <h6>{loanDetails.interestBearingRepayments}</h6>
                    </Col>
                  </Row>

                  <Row start="xs">
                    <Col xs={12} md={12} lg={12}>
                      <div className="border-row"></div>
                    </Col>
                  </Row>

                  <Row start="xs">
                    <Col xs={12} md={6} lg={6}>
                      <h5>
                        Repayment amount during <br />
                        interest-free period
                      </h5>
                    </Col>
                    <Col xs={9} md={6} lg={3} xsOffset={3}>
                      <h6>${loanDetails.interestFreeRepaymentAmount}*</h6>
                    </Col>
                  </Row>

                  <Row start="xs">
                    <Col xs={12} md={12} lg={12}>
                      <div className="border-row"></div>
                    </Col>
                  </Row>

                  <Row start="xs">
                    <Col xs={12} md={6} lg={6}>
                      <h5>
                        Repayment amount during <br />
                        interest-bearing period
                      </h5>
                    </Col>
                    <Col xs={9} md={6} lg={3} xsOffset={3}>
                      <h6>${loanDetails.interestBearingRepaymentAmount}**</h6>
                      {/* <h6>???</h6> */}
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
          </Row>
          <div className="gap-div"></div>
        </Grid>
      </div>
    );
  };

  const renderLoanCustomerTab = (loanCustomer: CustomerResourceBasic) => {
    return (
      <div className="details-wrapper-body">
        <Grid fluid>
          <Row>
            <Col xs={12} md={3} lg={3}>
              <h4>Customer Details</h4>
            </Col>

            <Col xs={11} md={9} lg={9}>
              <Row>
                <Col xs={12} md={6} lg={11} mdOffset={1}>
                  <Row start="xs">
                    <Col xs={12} md={6} lg={5}>
                      <h6 className="label">Customer Number</h6>
                      <InputField
                        name="customerNumber"
                        value={loanCustomer.customerNumber}
                        readOnly={true}
                      />
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row>
                <Col xs={12} md={6} lg={11} mdOffset={1}>
                  <Row start="xs">
                    <Col xs={12} md={6} lg={2}>
                      <h6 className="label">Title</h6>
                      <InputField
                        name="title"
                        value={loanCustomer.customerDetails?.title}
                        readOnly={true}
                      />
                    </Col>
                    <Col xs={12} md={6} lg={3}>
                      <h6 className="label">First Name</h6>
                      <InputField
                        name="firstName"
                        value={loanCustomer.customerDetails?.firstName}
                        readOnly={true}
                      />
                    </Col>

                    {loanCustomer.customerDetails?.middleName !== '' ? (
                      [
                        <Col xs={12} md={6} lg={3}>
                          <h6 className="label">Middle Name</h6>
                          <InputField
                            name="middleName"
                            value={loanCustomer.customerDetails?.middleName}
                            readOnly={true}
                          />
                        </Col>,

                        <Col xs={12} md={6} lg={3}>
                          <h6 className="label">Last Name</h6>
                          <InputField
                            name="lastName"
                            value={loanCustomer.customerDetails?.lastName}
                            readOnly={true}
                          />
                        </Col>,
                      ]
                    ) : (
                      <Col xs={12} md={6} lg={6}>
                        <h6 className="label">Last Name</h6>
                        <InputField
                          name="lastName"
                          value={loanCustomer.customerDetails?.lastName}
                          readOnly={true}
                        />
                      </Col>
                    )}
                  </Row>
                </Col>

                <Col xs={12} md={6} lg={11} mdOffset={1}>
                  <Row start="xs">
                    <Col xs={12} md={6} lg={5}>
                      <h6 className="label">Email</h6>
                      <InputField
                        name="email"
                        value={loanCustomer.customerDetails?.email}
                        readOnly={true}
                      />
                    </Col>
                    <Col xs={12} md={6} lg={6}>
                      <h6 className="label">Customer Mobile Number</h6>
                      <InputField
                        name="mobileNumber"
                        value={loanCustomer.customerDetails?.phone}
                        readOnly={true}
                      />
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
          </Row>
        </Grid>
      </div>
    );
  };

  return (
    <SCLoanDetails>
      <LoggedInLayout activePage="/loans" contentMarginTop={2}>
        <div className="loan-detail-body">
          <div className="view-all-loans">
            <h6>
              <IconChevron />
              <Link to="/loans" className="linkPage">
                <span>View all Loans</span>
              </Link>
            </h6>
          </div>
          {loading ? (
            <Loader />
          ) : (
            <>
              <div className="header">
                <h2>Loan Details</h2>
                {loanDetails.status.toLowerCase() === LOAN_APPROVED_STATUS &&
                parseFloat(loanDetails.establishmentFeeOutstanding) === 0 &&
                loanDetails.paymentStartDate &&
                !loanDetails.loanBlockActivation &&
                loanDetails.consentApproval &&
                (accessItems.activatePlans || accessItems.administrator) ? (
                  <h6>
                    <Button
                      className="button"
                      handleClick={() => setShowLoanActivationModal(true)}
                      colour="blue"
                    >
                      Activate Loan
                    </Button>
                  </h6>
                ) : (
                  ''
                )}
              </div>
              <div>
                <ModalWrapper
                  open={showLoanActivationModal}
                  handleClose={() => setShowLoanActivationModal(false)}
                  background="dark"
                >
                  {!submitSucceeded && !errorMessage ? (
                    <ModalGeneric
                      title={'Loan Activation'}
                      text={LOAN_ACTIVATION_CONFIRMATION}
                      primaryButton={
                        <Button
                          handleClick={() => dispatch(activateLoan('activate', loanDetails.id))}
                        >
                          Activate
                        </Button>
                      }
                      secondaryButton={
                        <Button
                          outline
                          colour="blue"
                          handleClick={() => setShowLoanActivationModal(false)}
                        >
                          Cancel
                        </Button>
                      }
                    ></ModalGeneric>
                  ) : (
                    <div className="message">{showMessage}</div>
                  )}
                </ModalWrapper>
              </div>

              <div>
                <Tabs
                  tabs={[
                    {
                      label: 'Loan Details',
                      children: renderLoanDetailsTab(loanDetails),
                    },
                    {
                      label: 'Customer Details',
                      children: renderLoanCustomerTab(loanCustomer),
                    },
                  ]}
                />
              </div>
            </>
          )}
        </div>
      </LoggedInLayout>
    </SCLoanDetails>
  );
};

export default LoanDetail;
